"use client";

import { useNotificationPoll } from "../hooks/use-notification-poll";

export function NotificationPollProvider() {
  useNotificationPoll();
  return null;
}
